import React, { useEffect } from 'react';
import { MainTable } from '../../../Components/Macro/MainTable/MainTable';
import { useLangsState } from './State';
import Add from './Add';
import Edit from './Edit';

function Langs() {
    let  { columns, langs, getNashr, setEd, deleteNashr } = useLangsState()

    useEffect(() => {
        getNashr()
    }, [])
    return (
        <MainTable 
            pageTitle={'Kitoblar tillari'}
            pcolumns={columns}
            pdata={langs}
            defkey={'id'}
            add={<Add />}
            edit={<Edit />}
            onEdit={(data) => {
                setEd(data)
            }}
            setEd={setEd}
            onDelete={deleteNashr}
        />
    );
}

export default Langs;